import { createSelector } from '@ngrx/store';
import { getMyZoneState, MyZoneState } from '../my-zone';
import * as fromCountry from './country.reducer';

/** @deprecated use OutCountriesModule from outshared-lib */
export const getCountryState = createSelector(getMyZoneState, (state: MyZoneState) => state.country);
/** @deprecated use OutCountriesModule from outshared-lib */
export const getEntities = createSelector(getCountryState, fromCountry.getEntities);
/** @deprecated use OutCountriesModule from outshared-lib */
export const getErrors = createSelector(getCountryState, fromCountry.getErrors);
/** @deprecated use OutCountriesModule from outshared-lib */
export const isLoading = createSelector(getCountryState, fromCountry.isLoading);
/** @deprecated use OutCountriesModule from outshared-lib */
export const isLoaded = createSelector(getCountryState, fromCountry.isLoaded);
